import { createReducer } from '@reduxjs/toolkit'
import ActionTypes from '@constants/action_types.js'
import { exists } from '@utils/functions.js'
import { mergeEntities } from '@utils/object.js'

export const initialState = {}

export const timelineGridItem = createReducer(initialState, builder => {
  builder
    .addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => receiveEntities(state, action))
    .addCase(ActionTypes.RECEIVE_TIMELINE_GRID_ITEMS, (state, action) => receiveGridItems(state, action))
})

export default timelineGridItem

function receiveEntities(state, action) {
  const { payload } = action
  if (payload.hasOwnProperty('grid_items')) {
    const { grid_items: entities } = payload
    state = mergeEntities(state, entities, {})
  }
  return state
}

function receiveGridItems(state, action) {
  const { payload: gridItems } = action
  if (exists(gridItems)) {
    return {
      ...state,
      ...gridItems,
    }
  }
  return state
}
